<template>
  <div style="height:100%">
    <div ref="fadeWhenModelOpen" style="height:100%">
      <div style="height:50px;" class="comm-settings-top-nav">
        <div class="col-md-12 justify-content-start p-0 h-100">
            <nav aria-label="breadcrumb" class="h-100">
              <ol class="breadcrumb comm-settings-top-nav m-0 h-100">
                <li class="comm-icon-rtl"><back-button  v-on:click.native="changeToSelectedScreensTableComponent('show-screens')"></back-button></li>
                <li class="breadcrumb-item active-text-nav-bar" aria-current="page">{{selectedScreenName}}</li>
                </ol>
            </nav>
        </div>
      </div>
      <div style="height: calc(100% - 60px);;overflow:auto">
        <table class="table users-basic-info-table" style="background: transparent;">
          <thead style="color: #eee">
            <tr>
              <th scope="col" style="width: 20%"></th>
              <th scope="col" style="width: 80%"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="key-div">{{$t('Screen Name')}}</td>
              <td class="value-div d-flex m-0">
                <div>
                  <div class="d-inline-flex">
                    <span v-show="!isMainEditting('name')">{{keyInfo.name}}</span>
                    <div class="dull-the-text" style="font-size:12px;position: relative;
                      top: 5px;inset-inline-start:3px">(non editable)
                    </div>
                  </div>          
                  <input type="text" id="name" v-show="isMainEditting('name')" class="bg-transparent border rounded text-light pl-1" style="width:331px;"
                    v-model="postInfo.name"
                  />
                </div>
              </td>
            </tr>
            <tr>
                <td class="key-div p-2" style="width:20%">{{$t("Screen Fields")}}</td>
                <td id="field_id_list" class="value-div d-flex m-0 p-2" style="width:80%;">                
                    <div  class="d-inline-flex">
                      <div  style="width: 100%;max-height:calc(100vh - 300px);min-height:30px">
                              <div class="value-style d-inline-flex bg-transparent rounded text-light input-fields searched-metadata-display-fields"
                              style="margin-top:5px;width:700px;">
                                  <ul class="tags-display-ul p-0 w-100 m-0" style=" display: grid;">
                                    <div style="display: grid;">
                                    <li class="add-screens-styles" @click="openFieldBrowser()">
                                      <div style="margin-inline-end:10px">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                        </svg>
                                      </div>
                                      <div style="font-size: 15px;line-height: 55px;">{{$t('Add Field(s) to Screen')}}</div>
                                    </li>
                                    <li>
                                        <draggable
                                          :list="selectedFieldsIdList"
                                          :disabled="false"
                                          class="list-group"
                                          ghost-class="ghost"
                                          :move="checkMove"
                                          @start="dragging = true"
                                          @end="dragging = false;UpdateFieldsReordering()"
                                        >
                                          <template v-for="fieldId in selectedFieldsIdList">
                                            <div class="list-group-item view-tags" style="color:#EEEEEE"  v-if="isFieldExists(fieldId)" :key="fieldId">
                                              <div class="screen-tags-name-display">
                                                  <div>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-list drag-icon" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                                                    </svg >
                                                  </div>
                                                  <div style="margin-inline-start: 5px !important" class="screens-name-styles">{{ getFieldName(fieldId) }}</div>
                                              </div>
                                              <div class="screen-tags-styles">
                                                <div class="view-sub-tags" v-if="displayAlwaysFieldIdsList.includes(fieldId)" style="background:#33691e">
                                                  <span>Display Always</span>
                                                  <cancel-icon class="show-tags-delete" @click.native="toggleDisplayAlwaysFields(fieldId)" style="float: inline-end;text-align: end"></cancel-icon>
                                                </div>
                                                <div class="view-sub-tags" v-if="mandatoryFieldIdsList.includes(fieldId)" style="background:#c3385c">
                                                  <span>Mandatory</span>
                                                  <cancel-icon class="show-tags-delete" @click.native="toggleMandatoryFields(fieldId)" style="float: inline-end;text-align: end;"></cancel-icon>
                                                </div>
                                                <div class="view-sub-tags" v-if="readonlyFieldIdsList.includes(fieldId)" style="background:#2f88d2">
                                                  <span>Readonly</span>
                                                  <cancel-icon class="show-tags-delete" @click.native="toggleReadOnlyFields(fieldId)" style="float: inline-end;text-align: end;"></cancel-icon>
                                                </div>
                                                <cancel-icon class="show-main-tag-delete" @click.native="removeField(fieldId)" style="float: inline-end;text-align: end;margin:8px;height:25px !important;width:25px !important"></cancel-icon>
                                                <div class="dropdown">
                                                  <div class="nav-item nav-link dropdown-toggle mr-md-2" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                                    <svg width="15" height="1.5em" viewBox="0 0 16 16" class="bi bi-three-dots more-actions-btn"  fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                                      <path fill-rule="evenodd" d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
                                                    </svg>
                                                  </div>
                                                  <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions">
                                                        <a class="dropdown-item p-2" @click.stop.prevent="toggleDisplayAlwaysFields(fieldId)">
                                                          Display Always</a>
                                                        <a class="dropdown-item p-2" @click.stop.prevent="toggleMandatoryFields(fieldId)">
                                                          Mandatory</a>
                                                        <a class="dropdown-item p-2" @click.stop.prevent="toggleReadOnlyFields(fieldId)">
                                                          Readonly</a>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </template>
                                        </draggable>
                                    </li>
                                    </div>
                                  </ul>
                              </div>
                              </div>
                      </div>
                </td>
            </tr>
          </tbody>
      </table>
      </div>
  </div>
    <field-browser v-if="isFieldBrowserEnabled" @saveFields="saveFieldBrowse" :screenName="selectedScreenName"
     @closeFieldsBrowser="closeFieldComponent" :selectedScreenFieldIds="selectedFieldsIdList"></field-browser>
  </div>
</template>

<script>
import CancelIcon from "../core/InlineCancelField.vue";
import {mapActions, mapGetters,mapMutations} from "vuex"
import Utils from "../../components.utils.js";
import BackButton from "../core/backButton.vue";
import FieldBrowser from "../customMetadata/FieldBrowser.vue"
import draggablePlugin from "vuedraggable";
import {NotifierConstants} from "../../components.constants.js";


export default {
  props: ["selectedScreenId","selectedScreenName"],
  data() {
    return {
      deletedFieldList:[],
      keyInfo: {},
      postInfo: {"field_id_list":[]},
      selectedValueIndex:-1,
      selectedFieldsIdList:[],
      displayAlwaysFieldIdsList:[],
      mandatoryFieldIdsList:[],
      readonlyFieldIdsList:[],
      fieldsList:[],
      fieldListFromAutocomplete:[],
      mainFieldKeyName:"",
      startUPFieldIdList:[],
      filterFieldBy:"",
      isFieldBrowserEnabled:false,
      refreshPage:false,
      dragging: false,
      selectedActionName:""
    };
  },
  computed: {
    draggingInfo() {
      return this.dragging ? "under drag" : "";
    }
  },
  components:{
    "field-browser":FieldBrowser,
    // "browse-icon":BrowseIcon,
    "cancel-icon": CancelIcon,
    "back-button":BackButton,
    "draggable": draggablePlugin,
  },
  methods : {
    selectTheJobName(option){
      this.selectedActionName = option.action_name;
      this.postInfo.action_id = option._id;
    },
    toggleDisplayAlwaysFields(fieldId){
      if(this.displayAlwaysFieldIdsList.includes(fieldId)){
        this.displayAlwaysFieldIdsList.splice(this.displayAlwaysFieldIdsList.indexOf(fieldId), 1);
      }else{
        this.displayAlwaysFieldIdsList.push(fieldId);
      }
      this.updateScreen('display_always_field_id_list');
    },
    toggleMandatoryFields(fieldId){
      if(this.mandatoryFieldIdsList.includes(fieldId)){
        this.mandatoryFieldIdsList.splice(this.mandatoryFieldIdsList.indexOf(fieldId),1);
      }else{
        this.mandatoryFieldIdsList.push(fieldId);
      }
      this.updateScreen('mandatory_field_id_list');
    },
    toggleReadOnlyFields(fieldId){
      if(this.readonlyFieldIdsList.includes(fieldId)){
        this.readonlyFieldIdsList.splice(this.readonlyFieldIdsList.indexOf(fieldId),1);
      }else{
        this.readonlyFieldIdsList.push(fieldId);
      }
      this.updateScreen('read_only_field_id_list');
    },
    cancelScreenUpdate(){
      this.mainFieldKeyName ='';
      this.fieldsList = this.keyInfo.field_id_list;
      this.selectedFieldsIdList = this.keyInfo.field_id_list;
    },
    checkMove: function(e) {
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    },
    cancelSelectedValue(){
      this.mainFieldKeyName = ""
      this.selectedValueIndex = -1
    },
    editMainField(fieldKey){
      this.cancelSelectedValue()
      this.mainFieldKeyName = fieldKey
    },
    isEditting(valueIndex) {
      return valueIndex === this.selectedValueIndex;
    },
    isMainEditting(fieldKey){
      return fieldKey == this.mainFieldKeyName;
    },
    getFieldsOnKeyup(){
      let fieldList = this.startUPFieldIdList.filter((_field)=>_field.name.toLowerCase().startsWith(this.filterFieldBy.toLocaleLowerCase()))
      if(typeof fieldList != "undefined" && fieldList.length > 0){
        this.fieldListFromAutocomplete = fieldList;
      }
      this.fieldListFromAutocomplete = []
    },
    isFieldExists(fieldId){
      if(this.deletedFieldList.includes(fieldId)){
        return false;
      }
      let fIndex = this.startUPFieldIdList.findIndex((_field)=>_field._id == fieldId)
      return (fIndex >= 0)
    },
    getCustomMetadataName(fieldInfo){
      if('language_alias_mapper' in fieldInfo && fieldInfo.language_alias_mapper && fieldInfo.language_alias_mapper.length > 0 && this.$i18n && this.$i18n.locale){
        let mapperExists = fieldInfo.language_alias_mapper.find(op=>op.code == this.$i18n.locale)
        if(mapperExists && Object.keys(mapperExists).length > 0 && mapperExists.field_alias && mapperExists.field_alias.length > 0){
          return mapperExists.field_alias;
        }
      }
      return fieldInfo.name;
    },
    getFieldName(fieldId){
      let fieldName = "";
      let fieldList = this.startUPFieldIdList.filter((_field)=>_field._id == fieldId)
      if(typeof fieldList != "undefined" && fieldList.length > 0){
        let fieldInfo = fieldList[0];
        fieldName = this.getCustomMetadataName(fieldInfo)
      }
      return fieldName;
    },
    removeField(fieldId){
      this.fieldsList.splice(this.fieldsList.indexOf(fieldId),1);
      console.log("remove field",this.fieldsList);
      this.updateScreen("field_id_list");
    },
    getActionName(actionId){
      let actionName = "";
      let actionsList = this.getActionListFromInMem().filter((_action) =>_action._id == actionId);
      if(typeof actionsList != "undefined" && actionsList.length >0){
        let actionInfo = actionsList[0];
        actionName = actionInfo.action_name;
      }
      return actionName
    },
    getJobNames(){
      console.log("this.getActionListFromInMem()",this.getActionListFromInMem())
      return this.getActionListFromInMem();
    },
    openFieldBrowser(){
      this.isFieldBrowserEnabled = true;
      this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
    },
    saveFieldBrowse(fieldIds){
      this.$refs.fadeWhenModelOpen.style.opacity = 1;
      let i= 0;
      this.fieldsList = [];
      if(fieldIds.length > 0){
        while(i <fieldIds.length){
          if(this.fieldsList.indexOf(fieldIds[i]) < 0){
            this.fieldsList.push(fieldIds[i]);
          }
          i++
        }
      }
      this.isFieldBrowserEnabled = false;
      this.updateScreen("field_id_list");
    },
    closeFieldComponent(){
      this.$refs.fadeWhenModelOpen.style.opacity = 1;
      this.isFieldBrowserEnabled = false;
    },
    UpdateFieldsReordering(){
      this.fieldsList = [];
      if(typeof this.selectedFieldsIdList != "undefined" && this.selectedFieldsIdList.length > 0){
        this.fieldsList = this.selectedFieldsIdList;
      }
      this.updateScreen("field_id_list");
    },
    updateScreen(field){
      let payload = {};
      if(field == 'action_id'){
        if(!Object.keys(this.postInfo).includes('action_id') ||
          typeof this.postInfo[field] == "undefined" ||
          this.postInfo[field].trim().length <= 0){
          alert("Please map screen action. ")
          document.getElementById("actionId").focus();
          return
        }
        payload[field] = this.postInfo[field];
      }
      else if(field == 'field_id_list'){
        if(typeof this.fieldsList == "undefined"){
          payload[field] = [];
        }else{
          payload[field] = this.fieldsList;
        }
      }
      else if(field == 'display_always_field_id_list'){
        if(typeof this.displayAlwaysFieldIdsList == "undefined"){
          payload[field] = [];
        }else{
          payload[field] = this.displayAlwaysFieldIdsList;
        }
      }
      else if(field == 'mandatory_field_id_list'){
        if(typeof this.mandatoryFieldIdsList == "undefined"){
          payload[field] = [];
        }else{
          payload[field] = this.mandatoryFieldIdsList;
        }
      }
      else if(field == 'read_only_field_id_list'){
        if(typeof this.readonlyFieldIdsList == "undefined"){
          payload[field] = [];
        }else{
          payload[field] = this.readonlyFieldIdsList;
        }
      }
      payload._id = this.selectedScreenId
      payload.params = { _id: this.selectedScreenId };
      this.updateExistingScreens(payload).then((data) => {
        if (Utils.isAcceptedStatusCode(data.statusCode)){
          this.$toast.success(data.message);
          if(field == 'action_id'){
            this.keyInfo[field] = this.postInfo[field];
          }
          if(field == 'field_id_list'){
            this.selectedFieldsIdList = this.fieldsList;
          }
        } else {
          this.$toast.error(data.message);
        }
        if(this.refreshPage){
          this.getScreenInfo();
        }
      });
      this.cancelSelectedValue();
    },
    getScreenInfo(){
      let payload = {};
      payload.params = { _id: this.selectedScreenId };
      this.getScreenInfoFromServer(payload).then((data)=>{
        this.keyInfo = data.screen;
        if(Object.keys(this.keyInfo).includes('action_id')){
            this.selectedActionName = this.getActionName(this.keyInfo.action_id);
        }
        this.selectedFieldsIdList = this.keyInfo.field_id_list;
        this.fieldsList = this.selectedFieldsIdList;
        if(Object.keys(this.keyInfo).includes('display_always_field_id_list')){
          this.displayAlwaysFieldIdsList = this.keyInfo.display_always_field_id_list;
        }else{
          this.displayAlwaysFieldIdsList = [];
        }
        if(Object.keys(this.keyInfo).includes('mandatory_field_id_list')){
          this.mandatoryFieldIdsList = this.keyInfo.mandatory_field_id_list;
        }else{
          this.mandatoryFieldIdsList = [];
        }
        
        if(Object.keys(this.keyInfo).includes('read_only_field_id_list')){
          this.readonlyFieldIdsList = this.keyInfo.read_only_field_id_list;
        }else{
          this.readonlyFieldIdsList = []
        }
      });
    },
    changeToSelectedScreensTableComponent(compName, payload = {}){
      this.$emit("changeToSelectedScreensTableComponent", compName, payload)
    },
    handleFieldsNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
          let entry_info = notification.message
          if(NotifierConstants.fieldRemovedNotification == notification.message_type){
            this.selectedFieldsIdList.splice(this.selectedFieldsIdList.indexOf(entry_info.custom_metadata_id));
          }
          else if([NotifierConstants.fieldCreatedNotification,
             NotifierConstants.fieldModifiedNotification,
             NotifierConstants.fieldRemovedNotification].includes(notification.message_type)){
            setTimeout(() => {
              this.refreshStartUpData();
              if(!this.isFieldBrowserEnabled ){
                this.refreshPage = false;
                this.getScreenInfo();
              }else{
                this.refreshPage = true;
              }
           }, 100)
          }else if(NotifierConstants.screenModifiedNotification == notification.message_type){
            if(this.selectedScreenId != entry_info.screen_id){
              this.refreshPage = false;
              return;
            }
            setTimeout(() => {
              if(!this.isFieldBrowserEnabled ){
                this.refreshPage = false;
                this.getScreenInfo();
              }else{
                this.refreshPage = true;
              }
            }, 100)
          }
        }
      },
      refreshStartUpData(){
        if(Object.keys(this.getStartUpDataFromInCache()).includes("custom_metadatas")){
          Object.assign(this.startUPFieldIdList,this.getStartUpDataFromInCache()["custom_metadatas"]);
        }
        this.startUPFieldIdList = this.startUPFieldIdList.concat([{"_id": "Tags","name": "Tags","screen_id_list": []},
                                    {"_id": "Upload path","name": "Upload path","screen_id_list": []},
                                    {"_id": "Description","name": "Description","screen_id_list": []},
                                    {"_id": "Catalogs","name": "Catalogs","screen_id_list": []}])
      },
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
    ...mapGetters("privileges",["getActionListFromInMem"]),
    ...mapActions("screens",["updateExistingScreens","getScreenInfoFromServer"])
  },
  created(){
    this.refreshStartUpData();
    this.getScreenInfo();
    this.addWSEventListener({
            eventname:[NotifierConstants.fieldRemovedNotification,NotifierConstants.fieldCreatedNotification,NotifierConstants.fieldModifiedNotification,NotifierConstants.screenModifiedNotification],
            callback:this.handleFieldsNotification,
            parent:"screenInfo"})
  },
  beforeDestroy(){
    this.removeWSEventListener({
            eventname:[NotifierConstants.fieldRemovedNotification,NotifierConstants.fieldCreatedNotification,NotifierConstants.fieldModifiedNotification,NotifierConstants.screenModifiedNotification],
            callback:this.handleFieldsNotification,
            parent:"screenInfo"})
  }
};
</script>


<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;
    $danger-color: #dc3545;
    $table-row-border: none;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    $border-on-hover: 1px solid #61707d;

.upload-fields{
    border: $border-color;
    width: 46%;
    border-radius: 5px;
    position:relative;
}

.users-basic-info-table {
  font-size: 15px;
  tbody {
    margin: 10px;
    .key-div {
      text-align: end;
      color: $dull-text-color;
    }
    .value-div {
      text-align: start;
      margin-inline-start: 10px;
    }
  }
}
table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      border-top: $table-row-border !important;
      border-bottom: $table-row-border !important;
    }
  }
  tbody {
    color: $text-color;
    td {
      border-top: $table-row-border !important;
    }
  }
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.view-tags {
    font-size: 12px!important;
    display: inline-flex!important;
    margin: 6px!important;
    border-radius: 15px!important;
    text-align: start;
    padding: 7px!important;
    justify-content: space-between;
    background:$primary-background;
    border:$border-color;
  span {
    margin-inline-start: 0px !important;
    font-size: 12px !important;
    border-radius: 15px !important;
    position: relative !important;
    top: 1px !important;
    width: 90%;
  }
}

.drag-icon{
  color:$dull-text-color;
  cursor: grab;
}

.editIcon {
  margin-inline-start: 9px;
}

.dull-the-text{
  color: $secondary-text-color;
}

.view-tags:hover, .view-sub-tags:hover {
  border: $border-on-hover !important;
}

.view-tags .show-main-tag-delete, .more-actions-btn {
  visibility: hidden;
}

.view-tags:hover{
  .show-main-tag-delete, .more-actions-btn {
    visibility: visible;
  }
} 

.editIcon{
  visibility:hidden;
}

.value-div:hover .editIcon{
    visibility: visible;
}

.show-tags-delete{
  visibility: hidden;
}

.view-sub-tags:hover .show-tags-delete{
  visibility: visible;
}

.searched-metadata-display-fields{
  height: 100%;
  width: 99%;
}

.show-main-tag-delete {
  margin-inline-start: 5px;
  margin-inline-end: 5px;
}

.search-bar-comm-style{
  height:30px;
  position:relative;
    margin-inline-start: 2%;
    margin-top: 5px;
  input{
    border:0px solid #202020;
    height: 25px;
    padding-inline-start: 3%;
  }
  svg{
    position: absolute;
    inset-inline-start:12px;
    top: 44%
  }
}

.btn {
  font-size: 14px !important;
  height: 100%;
}

.border {
  border: $border-color !important;
}

.custom-control-label::before {
  background-color: $primary-background;
}

.primary-btn-style {
  margin-top: 1%;
  position: absolute;
  inset-inline-end: 52%;
  button {
    height: 35px;
    width: 70px;
    font-size:14px;
  }
}

.validationmessage {
  color: $danger-color;
  font-size: 11px;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block;
    width: 20px;
    height: 19px;
    margin-top: 0px;
    margin-inline-start: -1px;
    border: $border-color;
    border-radius: .25em;
    background: transparent;
}

input[type="checkbox"]:checked:after {
  content: "✔";
  color: $active-blue;
  position: absolute;
  font-size: 16px;
  line-height: 1;
  transition: all 0.2s;
  font-family: Helvetica, Arial, sans-serif;
  padding-inline-start: 4px;
  padding-top: 2px;
}

.breadcrumb{
  padding: .75rem 1rem !important;
  background: $primary-background !important;
  align-items: center;
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}

.secondary-btn-style:hover{
  text-decoration: underline;
}
.secondary-btn-style{
  color:$text-color;
}

select{
  border: $border-color;
  background: $secondary-background-color;
  color: $text-color;
  height: 26px;
  width:137px;
  border-radius: 5px;
  padding-inline-start: 8px;
}

.screen-tags-name-display{
  display:inline-flex;
  line-height:44px;
  width:33%;
}

.screen-tags-styles{
  display:inline-flex;
  .view-sub-tags{
    font-size: 12px!important;
    height: 30px;
    display: inline-flex!important;
    margin: 5px!important;
    border: $border-color!important;
    border-radius: 15px!important;
    min-width: 50px!important;
    padding: 0!important;
    text-align: start;
    width: auto!important;
    padding-inline-start: 12px!important;
    justify-content: start;
    padding-top: 2px!important;
    span {
      margin-inline-start: 0!important;
      font-size: 12px!important;
      border-radius: 15px!important;
      position: relative!important;
      top: 3px!important;
      width: 90%;
    }
    .show-tags-delete{
      margin: 3px!important;
      float: inline-end;
      text-align: end;
      width: 25px;
      height: 25px;
      color: $text-color;
      position: relative;
      bottom: 4px;
    }
  }
}

.screens-name-styles{
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.tags-display-ul{
  list-style-type: none;
}

.add-screens-styles{
    display: inline-flex;
    height: 57px;
    border: 1px solid $add-button-border-color;
    border-radius: 10px;
    width: 97%;
    justify-content: center;
    line-height: 52px;
    margin: 8px 8px;
    color:$add-button-text-color;
}

.add-screens-styles:hover{
    border: 1px solid $add-button-border-on-hover;
    color:$add-button-text-color-hover;
}

.empty-field-text-styles{
  color:$none-text-color;
}

.config-desc{
  color: $dull-text-color;
}
</style>